import { Component, inject } from '@angular/core';
import { MethodBase } from '../base/method-base';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { PasscodeEmailAuthMethodViewModel } from '../../../../services/identity';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-method-passcode-email',
    templateUrl: './passcode-email.component.html',
    styleUrl: './passcode-email.component.scss',
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class PasscodeEmailComponent extends MethodBase {
  private fb = inject(FormBuilder);

  private passcodeEmailMethod: PasscodeEmailAuthMethodViewModel

  override ngOnInit(): void {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();
    if (!this.form.value.emailAddress && this.options.user.email) {
      this.form.controls['emailAddress'].setValue(this.options.user.email);
    }
  }


  setup(): void {
    this.passcodeEmailMethod = this.method as PasscodeEmailAuthMethodViewModel;
    this.form = this.fb.group({
      emailAddress: [this.passcodeEmailMethod.emailAddress, [Validators.required, Validators.email]]
    });
  }

  cancel(): void {
    this.setup();
  }

  override getMethod(): PasscodeEmailAuthMethodViewModel {
    this.passcodeEmailMethod.emailAddress = this.form.value.emailAddress;
    return this.passcodeEmailMethod;
  }
}
